// src/api/auth/customerAuth.ts
import { postRequest } from "../postRequest";

export type ApiResponse<T> = {
  success: boolean;
  errorCode?: string;
  errorDetail?: string;
  data?: T;
};

export type MusteriAuthResponse = {
  musteriId: number;
  token: string;
};

export type KayitOlRequest = {
  Ad: string;
  Soyad: string;
  Eposta?: string;
  Telefon?: string;
  Sifre: string;
};

export type GirisRequest = {
  Eposta?: string;
  Telefon?: string;
  Sifre: string;
};

export const kayitOl = async (req: KayitOlRequest) =>
  postRequest<KayitOlRequest, ApiResponse<MusteriAuthResponse>>(
    "/MusteriAuth/kayit-ol",
    req
  );

export const giris = async (req: GirisRequest) =>
  postRequest<GirisRequest, ApiResponse<MusteriAuthResponse>>(
    "/MusteriAuth/giris",
    req
  );
